export default __webpack_public_path__ + "static/media/bground.1dda0d16.png";